const TwitterSvg = ({
  height = 20,
  width = 19,
  viewBox = '0 0 20 19',
  fill = 'white',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  fill?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M15.75 0H18.8175L12.1175 7.6775L20 18.125H13.8287L8.995 11.7875L3.46375 18.125H0.395L7.56125 9.9125L0 0H6.32875L10.6975 5.79125L15.75 0ZM14.675 16.285H16.375L5.40375 1.74375H3.58125L14.675 16.285Z"
        fill={fill}
      />
    </svg>
  );
};

export default TwitterSvg;
/* const TwitterSvg = ({
  height = 14,
  width = 14,
  viewBox = '0 0 14 14',
  fill = 'white',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  fill?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M13.9726 2.66593C13.4484 2.89669 12.8932 3.04902 12.3247 3.11801C12.9232 2.75824 13.3714 2.19403 13.5864 1.52959C13.0317 1.85334 12.4168 2.08901 11.7623 2.22026C11.3305 1.75851 10.7583 1.45225 10.1346 1.34905C9.51091 1.24585 8.87057 1.35147 8.31305 1.64952C7.75552 1.94757 7.312 2.42136 7.05136 2.99733C6.79073 3.5733 6.72756 4.21921 6.87167 4.83476C4.48583 4.72217 2.37242 3.57592 0.956667 1.84459C0.699296 2.28198 0.565054 2.78086 0.568167 3.28834C0.568167 4.28584 1.07567 5.16259 1.8445 5.67767C1.38883 5.66317 0.943233 5.53997 0.544833 5.31834V5.35334C0.544575 6.01624 0.773657 6.65881 1.19321 7.17203C1.61277 7.68526 2.19696 8.03754 2.84667 8.16909C2.42567 8.2819 1.98474 8.29884 1.55633 8.21867C1.74074 8.78918 2.09864 9.28789 2.58009 9.64522C3.06155 10.0025 3.64254 10.2007 4.242 10.2119C3.22672 11.0087 1.97311 11.4412 0.6825 11.4398C0.455 11.4398 0.228083 11.4264 0 11.4008C1.31583 12.2433 2.8458 12.6905 4.40825 12.6893C9.68917 12.6893 12.5737 8.31667 12.5737 4.53142C12.5737 4.40892 12.5738 4.28642 12.565 4.16392C13.1285 3.75843 13.6146 3.25499 14 2.67759L13.9726 2.66593Z"
        fill={fill}
      />
    </svg>
  );
};

export default TwitterSvg;
 */
